<template>
  <div id="verify-email-success">
    <p><img src="/static/img/verifyEmail/success.png" alt="Verify email success"></p>
    <p class="text">{{ $t('congratulations') }}</p>
    <p class="text">{{ $t('successPrivilege') }}<span>{{ $t('freeTrail') }}</span></p>
    <router-link to="/dashboard">{{ $t('checkAccount') }}</router-link>
  </div>
</template>

<script>
  import locales from './lang'

  export default {
    name: 'verify-email-success',
    locales,
    beforeDestroy() {
      this.$store.commit('setShowVerifySuccess', false)
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../assets/scss/mixins/button";
  @import "../../assets/scss/mixins/gradient";

  #verify-email-success {
    img {
      max-width: .5rem;
    }
    p.text {
      color: #333333;
      line-height: .42rem;
      span {
        font-size: .34rem;
      }
    }
    a {
      display: inline-block;
      @include oval-button($color: #fff, $background-color: transparent, $border-color: .5rem, $min-width: 3rem, $height: .5rem);
      border: none;
      @include gradient-background(90deg, #416CF8 30%, #EC55FF 100%);
      font-size: .2rem;
      letter-spacing: 1.17px;
      margin-top: .6rem;
    }
  }

  @mixin pc-style() {
    #verify-email-success {
      width: 100%;
      max-width: 4rem;
      margin: 0 auto;
      p.text {
        font-size: .2rem;
        letter-spacing: 1.17px;
        span {
          font-size: .24rem;
        }
      }
    }
  }

  @mixin phone-style() {
    #verify-email-success {
      p.text {
        font-size: .16rem;
        letter-spacing: .5px;
      }
    }
  }

  @media (min-width: 768px) {
    @include pc-style();
  }

  @media (max-width: 767px) {
    @include phone-style();
  }
</style>



// WEBPACK FOOTER //
// VerifyEmailSuccess.vue?9664092c